module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loginout":" Log off"},"cn":{"loginout":"退出"}}')
  delete Component.options._Ctor
}
